<template>
  <div id="about-you">
    <div id="content">
      <div style="text-align: center;">
        <img
          class="malden-logo--big"
          src="@/assets/malden-logo-full.svg"
          alt="Malden Catholic Logo">
      </div>
      <div class="row">
        <div class="col-xs-12">
          <section-heading>About You</section-heading>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <about-you-form/>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <section-heading>About Your Child(ren)</section-heading>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <about-your-child-form/>
        </div>
      </div>
      <div class="row center-xs middle-xs">
        <div class="col-xs-12">
          <router-link
            to="/child-info/0"
            class="btn btn--yellow">Save &amp; Continue</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutYouForm from '@/components/about-you-form.vue';
import aboutYourChildForm from '@/components/about-your-child-form.vue';

export default {
  name: 'AboutYou',
  components: {
    aboutYouForm,
    aboutYourChildForm,
  },
};
</script>

<style lang="scss">
  #about-you {}
</style>
